(async () => {
  const { Core } = await importModule('Core');
  const { Swiper } = await importModule('Swiper');

  const ATTR_AUTOPLAY = 'autoplay';
  const CN_NAV_DISABLED = '!disabled';

  customElements.define('cro-v3-hero-slider', class extends Core {
    elements = {
      swiper: '[data-swiper]',
      next: '[data-next]',
      prev: '[data-prev]',
      pagination: '[data-pagination]'
    };

    render() {
      const slides = this.querySelectorAll('.swiper-slide');
      if (!slides.length || !this.$swiper) return;

      const loop = slides.length > 1;
      const swiperOptions = {
        loop,
        speed: 650,
        watchOverflow: true,
        grabCursor: loop
      };

      if (this.$pagination) {
        swiperOptions.pagination = {
          el: this.$pagination,
          clickable: true
        };
      }

      if (this.$next && this.$prev) {
        swiperOptions.navigation = {
          nextEl: this.$next,
          prevEl: this.$prev,
          disabledClass: CN_NAV_DISABLED
        };
      }

      if (this.autoplay) {
        swiperOptions.autoplay = {
          delay: this.autoplay,
          disableOnInteraction: false,
          pauseOnMouseEnter: true
        };
      }

      this.swiper = new Swiper(this.$swiper, swiperOptions);
      this.swiper.on('slideChange', () => this._syncVideos());
      this.swiper.on('init', () => this._syncVideos());
      this._syncVideos();
    }

    _syncVideos() {
      this.querySelectorAll('[data-hero-video-wrap] video').forEach((video) => {
        video.pause();
        video.currentTime = 0;
      });

      this.querySelectorAll('[data-hero-iframe]').forEach((iframe) => {
        const src = iframe.dataset.src || iframe.getAttribute('src') || '';
        if (!src) return;
        iframe.dataset.src = src;
        iframe.setAttribute('src', src.replace('autoplay=1', 'autoplay=0'));
      });

      const activeSlide = this.swiper?.slides?.[this.swiper.activeIndex];
      if (!activeSlide) return;

      const activeWrap = activeSlide.querySelector('[data-hero-video-wrap]');
      const activeVideo = activeWrap?.querySelector('video');
      if (activeVideo) {
        activeVideo.muted = activeWrap.dataset.muted !== 'false';
        activeVideo.play().catch(() => {});
        return;
      }

      const activeIframe = activeSlide.querySelector('[data-hero-iframe]');
      if (activeIframe) {
        const src = activeIframe.dataset.src || activeIframe.getAttribute('src') || '';
        if (!src) return;
        activeIframe.dataset.src = src;
        activeIframe.setAttribute('src', src.replace('autoplay=0', 'autoplay=1'));
      }
    }

    get autoplay() {
      return this.hasAttribute(ATTR_AUTOPLAY) ? Number(this.getAttribute(ATTR_AUTOPLAY)) : 0;
    }
  });
})();
